<div class="row">
  <div class="col-md-6">
    <form #quotaDistEntry="ngForm" class="form-horizontal">
      <div class="card card-body">
        <div class=" row ">
          <app-material-date-range
            class="col-md-6"
            id="date"
            [singleDateSelector]="true"
            [(dateRange)]="selectedDate"
            [jalali]="true"
            [disabled]="edit">
          </app-material-date-range>
          <app-material-organisation-selector
            class="col-md-6 pg-component"
            [(ngModel)]="company"
            [organisationLanguage]="'fa'"
            name="company"
            [organisations]="companies"
            [placeholder]="'نام شرکت'"
            [required]="true"
            [disabled]="edit">
          </app-material-organisation-selector>
        </div>
        <div class="form-group row ">
            <app-material-auto-complete
              name="type"
              [formatter]="formatType"
              [items]="typeList"
              [(ngModel)]="type"
              [placeholder]="'نوع'"
              (ngModelChange)="sourceFilter()"
              [required]="true"
              [disabled]="!company || edit">
            </app-material-auto-complete>
        </div>
        <div class="form-group row">
          <app-material-organisation-selector
            class="pg-component"
            [(ngModel)]="source"
            [organisationLanguage]="'fa'"
            name="source"
            [disabled] = "company === null || type === null"
            [organisations]="sources"
            [disabled]="edit"
            [placeholder]="'منبع '"
            [required]="true">
          </app-material-organisation-selector>
        </div>
        <div class="form-group row ">
          <app-material-pg-input
            label= "مقدار"
            type="text"
            name="value"
            id="value"
            [(ngModel)]="value"
            [disabled] = "company === null || type === null"
            [required]="true">
          </app-material-pg-input>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <app-material-pg-button
              class="pull-right"
              (clicked)="onSubmit()"
              [disabled]="!quotaDistEntry.form.valid"
              label="save">
            </app-material-pg-button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="col-md-12 visible-md visible-lg">
    <table class="table table-sm table-striped  table-bordered ">
      <thead>
        <tr>
          <td>تاریخ</td>
          <td>نوع</td>
          <td>نام شرکت</td>
          <td>منبع</td>
          <td>مقصد</td>
          <td>مقدار</td>
        </tr>
      </thead>
      @for (dt of importedData; track $index; let i = $index) {
        <tr>
          <td>{{dt.timestamp | persianDateOnly}}</td>
          <td>{{formatType(dt.quotaType)}}</td>
          <td>{{formatOrganisation(dt.organisationId)}}</td>
          <td>{{formatOrganisation(dt.sourceOrganisationId)}}</td>
          <td>{{formatOrganisation(dt.destination || '')}}</td>
          <td>{{dt.value}}</td>
        </tr>
      }
    </table>
  </div>
</div>